import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ContentItems } from "./ContentItems";
import { Group } from "../core/pdf/types";
import { GroupContext } from "./useGroup";
import { ElementTag } from "./ElementTag";

export function GroupEditor(props: {
	group: Group,
}) {
	const designer = useDesigner();

	const groupState = React.useMemo(() => {
		return {
			item: props.group, 
		}
	}, [props.group]);

	const elementContext = useElementContext(props.group);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const contentStyle = {};

	return (
		<ElementContext.Provider value={elementContext}>
			<GroupContext.Provider value={groupState}>
				<div
					className={"group-editor content-element flex align-start " + state.classes}
					data-key={props.group.id}
					id={state.elementID}
					tabIndex={0}
				>
					<ElementTag side="left" />

					<div style={contentStyle} className="fill">
						<ContentItems
							content={props.group.content}
						/>
					</div>
				</div>
			</GroupContext.Provider>
		</ElementContext.Provider>
	)
}